import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
// utils
// components
import MyAvatar from '../MyAvatar';
import Image from '../../fl-components/Image';
import cssStyles from '../../utils/cssStyles';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(() => ({
  '&:before': {
    ...cssStyles().bgBlur({ blur: 2, color: 'rgb(0 0 0 / 0%)' }),
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
    borderRadius: '16px'
  }
}));

const InfoStyle = styled('div')(({ theme }) => ({
  left: 0,
  right: 0,
  zIndex: 99,
  position: 'absolute',
  marginTop: theme.spacing(5),
  [theme.breakpoints.up('md')]: {
    right: 'auto',
    display: 'flex',
    alignItems: 'center',
    left: theme.spacing(3),
    bottom: theme.spacing(3)
  }
}));

// ----------------------------------------------------------------------

ProfilePage.propTypes = {
  userDetail: PropTypes.object
};

export default function ProfilePage({ userDetail }) {
  return (
    <RootStyle>
      <InfoStyle>
        <MyAvatar
          imageUrl={userDetail?.instituteProfileImage || userDetail?.profileImage}
          avatarText={userDetail?.name || userDetail?.fullName}
          sx={{
            mx: 'auto',
            borderWidth: 2,
            borderStyle: 'solid',
            borderColor: 'common.white',
            background: 'white',
            width: { xs: 80, md: 128 },
            height: { xs: 80, md: 128 }
          }}
        />
        <Box
          sx={{
            ml: { md: 3 },
            mt: { xs: 1, md: 0 },
            color: 'common.white',
            textAlign: { xs: 'center', md: 'left' }
          }}
        >
          <Typography variant="h4">{userDetail?.fullName ?? userDetail?.name}</Typography>
          {userDetail?.profile && (
            <Typography sx={{ opacity: 0.72, textTransform: 'capitalize' }}>
              {userDetail?.profile ?? userDetail?.role ?? userDetail?.orgType}
            </Typography>
          )}
        </Box>
      </InfoStyle>
      <Image
        alt="profile cover"
        disabledEffect
        src="https://cms.fainlearn.com/uploads/susan_q_yin_2_J_Ivbo_G_Leho_unsplash_6f16c6ccd1.jpg"
        sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, borderRadius: '16px' }}
      />
    </RootStyle>
  );
}
